import React, { useCallback, useMemo } from 'react';
import type { ContentSliderDesktopApi } from 'components/sliders/ContentSlider/types';
import type { ProductCardProduct } from 'components/product/ProductCard';
import ProductSliderCarousel from './ProductSliderCarousel';
import ProductSliderStaticGrid, { productSliderFitsStaticGrid } from './ProductSliderStaticGrid';

export interface ProductSliderDesktopProps {
    products: ProductCardProduct[];
    /** Wired to `SliderHeader` chevrons when the carousel is active (not static grid). */
    onReady?: (api: ContentSliderDesktopApi) => void;
}

/** Desktop: 24-col static row when all items fit; otherwise focused product carousel. */
const ProductSliderDesktop: React.FC<ProductSliderDesktopProps> = ({ products, onReady }) => {
    const shouldUseStaticGrid = useMemo(() => productSliderFitsStaticGrid(products), [products]);

    const handleSliderReady = useCallback(
        (api: ContentSliderDesktopApi) => {
            onReady?.(api);
        },
        [onReady],
    );

    if (products.length === 0) {
        return null;
    }

    return shouldUseStaticGrid ? (
        <ProductSliderStaticGrid products={products} />
    ) : (
        <ProductSliderCarousel products={products} onReady={handleSliderReady} />
    );
};

export default ProductSliderDesktop;
